import { useInfiniteQuery } from 'react-query';
import { accountService } from 'services';
import { ServerStateKeysEnum } from '../constants';

export const useDownloadHistory = () => {
  return useInfiniteQuery(
    `${ServerStateKeysEnum.downloadsHistory}`,
    ({ pageParam = 1 }) => accountService.getDownloadsHistory(pageParam),
    {
      getNextPageParam: (lastPage, pages) => {
        if (typeof lastPage.currentPageNumber === 'undefined') {
          return undefined;
        }

        if (lastPage.currentPageNumber === lastPage.totalPages) {
          return undefined;
        } else {
          return lastPage.currentPageNumber + 1;
        }
      },
      staleTime: Infinity,
    }
  );
};
